import { useState, useEffect } from 'react';
import { Table, Button } from 'react-bootstrap';
import Chart from './Chart';
import Layout from '../../wrappers/layout';
import './table.css';

const ChartComponent = () => {
  const [selectedButton, setSelectedButton] = useState(0); 
  const [selectedTimeFrame, setSelectedTimeFrame] = useState(5);

  const handleButtonClick = (buttonIndex) => {
    if (buttonIndex < 4) {
      setSelectedButton(buttonIndex);
    } else {
      setSelectedTimeFrame(buttonIndex);
    }
  };
  const metalCodes = ['Au', 'Ag', 'Pt', 'Pd'];
  const buttonNames = [
    'Gold',
    'Silver',
    'Platinum',
    'Palladium',
    '1D',
    '1W',
    '1M',
    '3M',
    '6M',
    '1Y',
  ];
  const renderButtons = () => {
    return buttonNames.map((buttonName, index) => (
      <Button
        key={index}
        variant='light'
        className={`rounded-square ${
          selectedButton === index || selectedTimeFrame === index
            ? 'selected'
            : ''
        }`}
        onClick={() => handleButtonClick(index)}
        style={{
          backgroundColor:
            selectedButton === index || selectedTimeFrame === index
              ? '#301250'
              : '#fff',
          fontWeight: 'bold',
          color:
            selectedButton === index || selectedTimeFrame === index
              ? '#fff'
              : '#000',
          border: '1px solid #ccc',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          margin: '5px',
          fontSize: '14px',
        }}
      >
        {buttonName}
      </Button>
    ));
  };


  useEffect(() => {
    document.title = "Price Chart - eBullion "
  }, []);

  return (
    <Layout>
      <div>
        <div className='chart-table-responsive'>
          <Table striped bordered className='custom-table-chart'>
            <tbody>
              <tr>
                <td colSpan={3} className='small-width'>
                  {renderButtons()}
                </td>
              </tr>
              <tr className='white-background'>
                <td colSpan={3} className='bigger-width'>
                 
                  <Chart
                    selectedMetal={metalCodes[selectedButton]}
                    selectedDuration={buttonNames[selectedTimeFrame]}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Layout>
  );
};

export default ChartComponent;
